import { FilterOptionKeys } from '@griply/types';
import { typeFilterOptions } from '@griply/utils';
import { TFunction } from 'i18next';
import { Repeat } from 'shared/assets/icons';
import { FilterOptionType, FilterSelectOption } from 'shared/types/filter';
import { TaskType } from 'shared/types/task-base';

export type Options = {
  t: TFunction;
};

const typeLabelKeys: Record<TaskType, string> = {
  [TaskType.Task]: 'context-menus.filtering.task.filters.type.options.task',
  [TaskType.Repeating]:
    'context-menus.filtering.task.filters.type.options.repeating',
  [TaskType.Habit]: 'context-menus.filtering.task.filters.type.options.habit',
};

export const createTypeFilter = ({ t }: Options): FilterSelectOption => ({
  id: FilterOptionKeys.Type,
  label: t('general.filters.title.type'),
  placeholder: t('general.labels.select'),
  icon: Repeat,
  type: FilterOptionType.MultiSelect,
  selectOptions: typeFilterOptions.map((value) => ({
    label: t(typeLabelKeys[value]),
    value,
  })),
  canReset: true,
});
